<template>
    <div class="mt-2 mb-4">
        <v-btn color="red-darken-4" variant="elevated" elevation="0" @click="show_confirm_delete = true">Supprimer
            la commande</v-btn>
        <v-dialog v-model="show_confirm_delete" width="500" max-width="100%" scroll-strategy="none">
            <v-card>
                <v-card-text>
                    <div>
                        Toutes les préinscriptions (parcours, options et dossards) associées à cette commande seront
                        supprimées. Ces préinscriptions ne seront plus disponibles dans l'interface de validation. Le
                        client ne sera pas prélevé.
                    </div>
                    <div class="text-body-1">Voulez-vous vraiment <b>supprimer</b> cette commande ?</div>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red-darken-4" @click="show_confirm_delete = false">Non</v-btn>
                    <v-btn color="green-darken-4" @click="handle_delete">Oui</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import AdminService from "@/services/admin.service.js";
export default {
    props: ["id_commande"],
    data() {
        return {
            show_confirm_delete: false,
        };
    },
    methods: {
        async handle_delete() {
            this.show_confirm_delete = false;
            let request = await AdminService.deletePreInscription(this.id_commande);

            if (!request.error) {
                this.$emit("delete_commande");
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>